import * as React from 'react';
import { Image, TouchableOpacity } from 'react-native';
import { IconSvg } from 'src/assets';
import { OperatorProps } from 'src/common/api/response';
import { Container, RegularText, Row, SizedBox } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';

export const Operator = ({
  operator,
  busService,
  style,
  onRatingPress,
  showRating = true,
}: {
  style?: any;
  operator?: OperatorProps;
  busService?: string;
  onRatingPress?: () => void;
  showRating?: boolean;
}) => {
  return (
    <Row style={[{ flex: 1, height: pixelScaler(36), alignItems: 'flex-start' }, style]}>
      <Image
        resizeMode="contain"
        source={{ uri: operator?.image }}
        style={{ width: pixelScaler(36), height: pixelScaler(36) }}
      />
      <SizedBox width="medium" />
      <Container flex height="100%" style={{ justifyContent: 'space-between' }}>
        <Row flex marginRight={metrics.tiny}>
          <RegularText style={{ marginRight: metrics.medium }} numberOfLines={1} fontWeight="bold">
            {operator?.name}
          </RegularText>
          {showRating && <Rating rating={operator?.rating || 0} onPress={onRatingPress} />}
        </Row>
        <RegularText>{busService}</RegularText>
      </Container>
    </Row>
  );
};

export const SmallOperator = ({ operator, style }: { style?: any; operator?: OperatorProps }) => {
  return (
    <Row style={[{ alignItems: 'center' }, style]}>
      <Image
        resizeMode="contain"
        source={{ uri: operator?.image }}
        // source={{ uri: 'https://imagery.go24.tech/media/upload/banners/023021712042828253.jpg' }}
        style={{ width: pixelScaler(18), height: pixelScaler(18) }}
      />
      {/* <Image
        source={Assets.Nham24Icon}
        style={{
          borderWidth: 3,
          borderColor: AppColors.white,
          borderRadius: 20,
          width: pixelScaler(28),
          height: pixelScaler(28),
          position: 'absolute',
          alignSelf: 'center',
        }}
      /> */}
      <SizedBox height={0} width="small" />
      <Container>
        <RegularText>{operator?.name}</RegularText>
      </Container>
    </Row>
  );
};

const Rating = ({ rating, onPress }: { rating: number; onPress?: () => void }) => {
  return (
    <TouchableOpacity disabled={!onPress} activeOpacity={0.8} onPress={onPress}>
      <Row
        style={{
          borderRadius: 10,
          backgroundColor: AppColors.ratingBackground,
          paddingVertical: metrics.tiny,
          paddingHorizontal: metrics.small,
          alignItems: 'center',
          borderWidth: 1,
          borderColor: AppColors.ratingBorder,
        }}>
        <IconSvg.StarOutline />
        <SizedBox height={0} width={metrics.small} />
        <RegularText fontSize="medium">{rating}</RegularText>
      </Row>
    </TouchableOpacity>
  );
};
